import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { translate } from '@jsverse/transloco';
import { formatNumber } from 'humanize-plus';

import { capitalize } from 'humanize-plus';
import { Subscription } from 'rxjs';

import { DropdownObject } from '@inmoment/the-kitchen';
import { RGBAColor } from '@inmoment/the-kitchen/src/lib/Pickers/ColorPicker/ColorPicker.model';

import { Scale } from 'app/components/uikit/lex-horizontal-stepper/lex-horizontal-stepper.component';
import { Constants } from 'app/constants/constants';
import {
  AnalyticItemTypeMap,
  AnalyticItemTypes,
} from 'app/modules/dashboard/services/analytic-item-types';
import { TagCacheService } from 'app/modules/dashboard/services/tag-cache.service';
import { DashboardValidityChecks } from 'app/modules/dashboard/services/validity-checks';
import {
  DatasourceManagerStore,
  DatasourcesType,
} from 'app/modules/dashboard/stores/datasource-manager.store';
import { CustomFieldsService } from 'app/modules/field/custom-fields.service';
import { WidgetKeyDriverAnalysisDataSource } from 'app/modules/widget/components/widget-data-source.component';
import { LexDatePipe } from 'app/pipes/lex-date.pipe';
import { AuthService } from 'app/providers/bridge-api/auth.service';
import {
  Comparison,
  Dashboard,
  Widget,
  WidgetDefault,
  WidgetGroup,
  WidgetUtility,
} from 'app/providers/bridge-api/dashboard.service';
import { FieldStatisticsService } from 'app/providers/field-statistics.service';
import { SpotEService } from 'app/providers/semantria-api/spote.service';
import { StorageAccountService } from 'app/providers/storage-api/blender-account.service';
import { SectionMetadata } from 'app/providers/storage-api/collection.service';
import { Report, ReportService } from 'app/providers/storage-api/report.service';
import { LoggerService } from 'app/services/logger.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { SectionService } from 'app/services/section.service';

import { TimezoneService } from 'app/services/timezone.service';
import { FilterUtils } from 'app/utils/filter.utils';
import { Utils } from 'app/utils/utils';
import { WidgetDataSource } from '../../../../models';
import { Field, FieldService } from '../../../../providers/storage-api/field.service';
import { FilterService } from '../../../collection/services/filter.service';
import {
  BoxScoringDisplayData,
  BoxScoringDisplayDataUtils,
} from '../box-scoring-display/box-scoring-display.component';

import {
  AutocompleteState,
  DataSourceChooserComponent,
} from '../data-source-chooser/data-source-chooser.component';

import { NumericMetadataField } from '../numeric-metadata-field-selector/numeric-metadata-field-selector.models';

import { SelectedSection } from '../section-selector/section-selector.component';
import { BreakdownOptions, FieldBucketDefinition } from '../widget-chart/widget-chart.component';
import { WidgetInsightFeedSource } from '../widget-insight-feed/widget-insight-feed.component';
import { WidgetService } from '../../services/widget.service';

export interface WidgetAddDialogOptions {
  dashboard: Dashboard;
  dashboardDataSource: WidgetDataSource;
  dashboardKeyDriverDataSource?: WidgetKeyDriverAnalysisDataSource;
  dataSources: DatasourcesType;
  widget?: Widget;
  widgetGroup?: WidgetGroup;
  comparison?: Comparison;
  defaultColorPalette?: RGBAColor[];
  projectPalette?: Array<{ color: RGBAColor }>;
}

interface AnalyticItem {
  key: string;
  count: number;
}

export interface MetadataField {
  name: string;
  label: string;
  type: string;
  isRating: boolean;
  isRedacted: boolean;
  aliasedFields?: string[];
  isDisplayed: boolean;
  calculationFieldType?: string;
  calculationType?: string;
}

type StateType = 'start' | 'item-picker' | 'metadata-picker';

export interface WidgetAddBreakdownAxisOptions {
  primary: Partial<WidgetAddBreakdownAxisOption>;
  secondary: Partial<WidgetAddBreakdownAxisOption>;
}

export interface WidgetAddBreakdownAxisOption {
  numericMetadataFieldId: string;
  scoringSet?: DropdownObject[];
  scoring: string;
  fieldBuckets?: FieldBucketDefinition[];
  min?: number;
  max?: number;
  boxScoringDisplayData?: BoxScoringDisplayData;
  isMetadataBinary?: boolean;
}

type BreakdownAxisKey = keyof WidgetAddBreakdownAxisOptions;

@EnableClassTelemetry()
@Component({
  selector: 'app-widget-add-dialog',
  templateUrl: './widget-add.component.html',
  styleUrls: ['./widget-add.component.scss'],
  standalone: false,
})
export class WidgetAddDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() data: WidgetAddDialogOptions;

  @Output() modalClosed = new EventEmitter<Widget<WidgetDefault>>();

  @ViewChild(DataSourceChooserComponent) datasourceChooser: DataSourceChooserComponent;
  @ViewChild('elementItemTypeInput') elementItemTypeInputElement: MatSelect;
  @ViewChild('elementItemInput') elementItemInputElement: ElementRef;
  @ViewChild('elementMetadataInput') elementMetadataInputElement: MatSelect;
  @ViewChildren('widgetListItem', { read: ElementRef }) widgetListItems: QueryList<ElementRef>;

  readonly datasourceManagerStore = inject(DatasourceManagerStore);

  selectedItemAc: AutocompleteState = {
    timeout: null,
    inProgress: false,
    results: [],
    filteredResults: [],
  };
  component = '';
  widgetEditOptions: WidgetAddDialogOptions;
  widget: Widget<WidgetDefault>;
  isCustomDateSelected: boolean;
  isCustomDoubleSelected: boolean;
  isCustomLongSelected;

  ds: WidgetDataSource;
  state: StateType = 'start';
  itemsToDisplay: 'top' | 'custom' = 'top';
  analyticItems: AnalyticItemTypeMap = {};
  analyticItemTypeKeys: string[] = [];
  dsMetadataFields: MetadataField[] = [];
  accountMetadataFields: Field[] = [];

  selectedAxis: 'row' | 'column' = 'row';
  originalRowItems = [];
  originalColumnItems = [];
  selectedItem = '';
  canSelectMultiple = false;
  isBlankChecked = false;
  blankCount = 0;

  analyticItemTypeClassRef = AnalyticItemTypes;
  private ENTITY_SUB_TYPES_LABEL = translate('widgets.widget-add.entity-types');
  private TOPIC_SUB_TYPES_LABEL = translate('widgets.widget-add.topic-types');
  private CUSTOM_FIELD_LABEL = translate('widgets.widget-add.custom-fields');
  private STANDARD_FIELD_LABEL = translate('widgets.widget-add.standard-fields');
  private DEFAULT_LABEL = translate('widgets.widget-add.defaults');

  groupFieldsLoading = true;
  private groupFieldsSub$: Subscription;
  private widgetGroup?: WidgetGroup;
  private comparison?: Comparison;

  private numericMetadataFields: NumericMetadataField[];
  isNmotFieldSelectorValid = false;

  private readonly _breakdownScoringSet: DropdownObject[] = [
    { title: translate('widgets.widget-add.average'), id: 'avg' },
    { title: translate('widgets.widget-add.box'), id: 'box' },
    { title: translate('widgets.widget-add.buckets'), id: 'bucket' },
    { title: translate('widgets.widget-add.sum'), id: 'sum' },
    { title: translate('widgets.widget-add.nps'), id: 'nps' },
  ];
  breakdownFieldSet: DropdownObject[];
  breakdownField: string;
  breakdownNumericMetadataFieldSet: DropdownObject[];
  breakdownSecondaryNumericMetadataFieldSet: DropdownObject[];

  breakDownOptions: WidgetAddBreakdownAxisOptions = {
    primary: {},
    secondary: {},
  };
  breakdownBoxStepperScale: Scale = {
    min: 0,
    max: 10,
    step: 1,
  };
  breakdownNpsStepperScaleFrom: Scale = {
    min: 0,
    max: 1,
    step: 1,
  };
  breakdownNpsStepperScaleTo: Scale = {
    min: 2,
    max: 100,
    step: 1,
  };
  note = { text: '', displayTitle: false };

  readonly availableWidgets = [
    {
      type: 'bigNumber',
      buttonLabel: translate('widgets.widget-add.big-number'),
      isMultiStep: true,
    },
    {
      type: 'breakdown',
      buttonLabel: translate('widgets.widget-add.breakdown'),
      isMultiStep: true,
    },
    {
      type: 'crosstab',
      buttonLabel: translate('widgets.widget-add.crosstab'),
      customItems: true,
    },
    {
      type: 'documents',
      buttonLabel: translate('widgets.widget-add.documents'),
    },
    {
      type: 'donut',
      buttonLabel: translate('widgets.widget-add.donut'),
      isMultiStep: true,
    },
    {
      type: 'focusAreas',
      buttonLabel: translate('widgets.widget-add.focus'),
      isMultiStep: true,
    },
    {
      type: 'gauge',
      buttonLabel: translate('widgets.widget-add.gauge'),
      isMultiStep: true,
    },
    {
      type: 'grid',
      buttonLabel: translate('widgets.widget-add.grid'),
      isMultiStep: true,
    },
    {
      type: 'impact',
      buttonLabel: translate('widgets.widget-add.impact'),
      isMultiStep: true,
    },
    {
      type: 'insightFeed',
      buttonLabel: translate('widgets.widget-add.insight-feed'),
    },
    {
      type: 'predictor',
      buttonLabel: translate('widgets.widget-add.impact-predictor'),
    },
    {
      type: 'journey',
      buttonLabel: translate('widgets.widget-add.journey'),
      isMultiStep: true,
    },
    {
      type: 'note',
      buttonLabel: translate('widgets.widget-add.note'),
    },
    {
      type: 'noteMarkdown',
      buttonLabel: translate('widgets.widget-add.note-markdown'),
    },
    {
      type: 'numericMetadata',
      buttonLabel: translate('widgets.widget-add.numeric-metadata-over-time'),
      overTime: true,
      isMultiStep: true,
    },
    {
      type: 'scatterPlot',
      buttonLabel: translate('widgets.widget-add.scatter-plot'),
      customItems: true,
    },
    {
      type: 'sentimentScore',
      buttonLabel: translate('widgets.widget-add.sentiment'),
      customItems: true,
    },
    {
      type: 'sentimentAccuracy',
      buttonLabel: translate('widgets.widget-add.sentiment-accuracy'),
      isMultiStep: true,
      disabled: false,
      tooltip: undefined,
    },
    {
      type: 'sentimentScore',
      overTime: true,
      buttonLabel: translate('widgets.widget-add.sentiment-over-time'),
      customItems: true,
    },
    {
      type: 'sentimentPolarity',
      buttonLabel: translate('widgets.widget-add.sentiment-polarity'),
      customItems: true,
    },
    {
      type: 'sentimentVolume',
      buttonLabel: translate('widgets.widget-add.sentiment-vs-volume-over-time'),
      overTime: true,
      isMultiStep: true,
    },
    {
      type: 'taxonomyMap',
      buttonLabel: translate('widgets.widget-add.taxonomy-map'),
    },
    {
      type: 'featureScoring',
      buttonLabel: translate('widgets.widget-add.tuning-feature-scoring'),
      isMultiStep: true,
      customItems: true,
    },
    {
      type: 'documentCount',
      buttonLabel: translate('widgets.widget-add.volume'),
      customItems: true,
    },
    {
      type: 'documentCount',
      buttonLabel: translate('widgets.widget-add.volume-over-time'),
      overTime: true,
      customItems: true,
    },
    {
      type: 'wordcloud',
      buttonLabel: translate('widgets.widget-add.word-cloud'),
      customItems: true,
    },
    {
      type: 'powerScore',
      buttonLabel: translate('widgets.widget-add.power-score'),
    },
    {
      type: 'powerScoreOverTime',
      overTime: true,
      buttonLabel: translate('widgets.widget-add.power-score-over-time'),
    },
  ];
  selectedWidget;

  floatMetadataFieldNames: string[] = [];

  newspaperProperties = {
    enabled: false,
    scene: null,
    tooltip: {
      text: translate('widgets.widget-add.include-snapshot-tooltip'),
      direction: 6,
    },
  };
  breakdownSecondaryAxisAdded = false;
  bucketProjectPalette: Array<{ color: RGBAColor }> = [];
  bucketValidationError: Partial<Record<BreakdownAxisKey, string>> = {};
  private readonly defaultBucketDefinitionsByField = new Map<string, FieldBucketDefinition[]>();

  sectionMetadata: SectionMetadata[] = [];
  sectionSelectionText?: string;
  isSectionMetadataLoaded = false;
  private sectionMetadataLoadId = 0;

  constructor(
    private reportService: ReportService,
    private accountService: StorageAccountService,
    private tagCacheService: TagCacheService,
    private lexDatePipe: LexDatePipe,
    private fieldService: FieldService,
    private fieldStatisticsService: FieldStatisticsService,
    private filterService: FilterService,
    private authService: AuthService,
    private timezoneService: TimezoneService,
    private sectionService: SectionService,
    private widgetService: WidgetService,
    private customFieldService: CustomFieldsService,
    private spoteService: SpotEService,
    private logger: LoggerService
  ) {}

  ngOnInit() {
    this.widgetEditOptions = { ...this.data };
    this.widgetGroup = this.data.widgetGroup;
    this.comparison = this.data.comparison;
    this.ds = this.widgetEditOptions.dashboardDataSource;

    this.bucketProjectPalette =
      this.data.projectPalette ??
      this.data.defaultColorPalette?.map((color: RGBAColor) => ({ color })) ??
      [];

    this.disableAvailableWidgetsBasedOnOptions();

    if (this.widgetEditOptions.widget && this.widgetEditOptions.widget.dataSourceId) {
      this.ds = this.datasourceManagerStore.getById(this.widgetEditOptions.widget.dataSourceId);
      this.widget = JSON.parse(JSON.stringify(this.data.widget));
      if (this.widget.payload.limit === -1) {
        this.canSelectMultiple = true;
      }
      this.state = 'item-picker';

      if (
        (this.widget.payload.type === 'featureScoring' &&
          !this.widget.payload.selectedItems.length) ||
        this.widget.payload.type === 'sentimentAccuracy' ||
        this.widget.payload.type === 'numericMetadata' ||
        this.widget.payload.type === 'donut' ||
        this.widget.payload.type === 'gauge'
      ) {
        this.state = 'metadata-picker';

        if (this.widget.payload.type === 'numericMetadata') {
          this.isNmotFieldSelectorValid = true;
        }
      } else if (this.widget.payload.type === 'breakdown') {
        this.state = 'metadata-picker';

        this.breakdownField = this.widget.payload.breakdownOptions.fieldId;
        this.widget.payload.customFieldSelected = false;
        this.widget.payload.standardFieldSelected = false;
        this.widget.payload.sectionPropertySelected = this.breakdownField?.startsWith(
          Constants.SECTION_PROPERTIES_PREFIX
        );
        if (!this.widget.payload.sectionPropertySelected) {
          this.widget.payload.customFieldSelected = FieldService.isCustomField(this.breakdownField);
          this.widget.payload.standardFieldSelected = !this.widget.payload.customFieldSelected;
        }

        const axisOptionObjectAssembler = (
          opts: BreakdownOptions
        ): WidgetAddBreakdownAxisOption => {
          const { topColor, neutralColor, bottomColor } =
            BoxScoringDisplayDataUtils.getObjectDefaults();
          return {
            numericMetadataFieldId: opts.numericMetadataFieldId,
            scoring: opts.scoring,
            ...(opts.scoring === 'bucket' && {
              fieldBuckets: opts.fieldBuckets,
            }),
            ...((opts.scoring === 'box' || opts.scoring === 'nps') && {
              min: opts.min,
              max: opts.max,
            }),
            ...(opts.scoring === 'box' && {
              boxScoringDisplayData: {
                isTopShown: opts.isTopShown,
                isNeutralShown: opts.isNeutralShown,
                isBottomShown: opts.isBottomShown,
                topBoxSize: opts.topBoxSize,
                bottomBoxSize: opts.bottomBoxSize,
                topColor: opts.topColor ?? topColor,
                neutralColor: opts.neutralColor ?? neutralColor,
                bottomColor: opts.bottomColor ?? bottomColor,
                defaultColorPalette: this.data.defaultColorPalette,
              },
            }),
          };
        };

        const applyBreakdownOptions = (
          payloadKey: 'breakdownOptions' | 'additionalBreakdownOptions',
          breakdownOptionsKey: BreakdownAxisKey
        ): void => {
          const opts: BreakdownOptions = this.widget.payload[payloadKey] as BreakdownOptions;
          if (!opts?.numericMetadataFieldId || !opts?.scoring) {
            return;
          }
          const axisOptionObject = axisOptionObjectAssembler(opts);
          if (axisOptionObject.scoring === 'nps') {
            axisOptionObject.min ??= 0;
            axisOptionObject.max ??= 10;
          }
          this.breakDownOptions[breakdownOptionsKey] = axisOptionObject;
        };
        applyBreakdownOptions('breakdownOptions', 'primary');
        applyBreakdownOptions('additionalBreakdownOptions', 'secondary');
        this.breakdownSecondaryAxisAdded =
          !!this.breakDownOptions.secondary.numericMetadataFieldId &&
          !!this.breakDownOptions.secondary.scoring;
        if (this.breakDownOptions.primary.scoring === 'bucket') {
          this.ensureBucketDefaults('primary');
          this.updateBucketValidation('primary');
        }
        if (this.breakDownOptions.secondary.scoring === 'bucket') {
          this.ensureBucketDefaults('secondary');
          this.updateBucketValidation('secondary');
        }
        this.refreshBucketExclusivity();
      }
    } else {
      this.selectWidget(this.availableWidgets.find((w) => !w.disabled));
    }

    this.updateSectionSelectorAvailability();

    this.groupFieldsSub$ = this.accountService.groupFieldsSub.subscribe(async (accountMetadata) => {
      this.accountMetadataFields = accountMetadata.metadata.filter(
        (f) => f.metadata?.display !== false
      );
      this.defaultBucketDefinitionsByField.clear();

      let fieldTypes;

      if (this.widgetEditOptions.widget) {
        if (
          (this.widget.payload.type === 'featureScoring' &&
            !this.widget.payload.selectedItems.length) ||
          this.widget.payload.type === 'sentimentAccuracy'
        ) {
          fieldTypes = 'keyword';
        } else if (this.widget.payload.type === 'numericMetadata') {
          fieldTypes = ['double', 'long'];
        } else if (this.widget.payload.type === 'breakdown') {
          fieldTypes = ['double', 'long', 'keyword'];
        } else if (this.widget.payload.type === 'donut') {
          fieldTypes = ['long'];
        } else if (this.widget.payload.type === 'gauge') {
          fieldTypes = ['rating'];
        }
      }

      await this.findDatasourceFields(fieldTypes);
      this.groupFieldsLoading = false;

      if (this.widget.payload.type === 'breakdown') {
        this.setBreakdownFields();
      }
    });

    this.prepareAnalyticItems().then((items) => {
      this.analyticItems = items;
      this.analyticItemTypeKeys = Object.keys(this.analyticItems);

      const prepareItemAndSubtype = (
        analyticItemProp,
        entityTypeProp,
        selectedItemsProp,
        originalSelectedItemsProp
      ) => {
        if (
          (this.data.widget.payload[analyticItemProp] === 'entities' ||
            this.data.widget.payload[analyticItemProp] === 'topics') &&
          this.data.widget.payload[entityTypeProp]
        ) {
          this.widget.payload[analyticItemProp] = this.data.widget.payload[entityTypeProp];
        }

        this.updateAnalyticItems({ target: { value: '' } });

        if (this.widget.payload[selectedItemsProp]) {
          this.widget.payload[selectedItemsProp] = [...this.data.widget.payload[selectedItemsProp]];
          this[originalSelectedItemsProp] = [...this.widget.payload[selectedItemsProp]];
        }
      };

      if (this.data.widget) {
        prepareItemAndSubtype(
          'analyticItem',
          'entityTypeFilter',
          'selectedItems',
          'originalRowItems'
        );

        if (this.data.widget.payload.columnAnalyticItem) {
          prepareItemAndSubtype(
            'columnAnalyticItem',
            'columnEntityTypeFilter',
            'columnSelectedItems',
            'originalColumnItems'
          );
        }
      }

      this.toggleBlank(!!this.widget.payload.showBlanks);
    });

    if (!this.widgetEditOptions.widget) {
      this.spoteService.listScenes({ type: 'DAILY_NEWSPAPER_V2' }).then((res) => {
        if (!res.total_elements) {
          this.newspaperProperties.tooltip = {
            text: translate('widgets.widget-add.snapshot-not-available'),
            direction: 6,
          };
          return;
        }
        this.newspaperProperties.enabled = true;
        this.newspaperProperties.scene = res.data[0].scene_id;
      });
    }
  }

  ngAfterViewInit(): void {
    this.scrollSelectedWidgetToView();
  }

  private scrollSelectedWidgetToView(): void {
    setTimeout(() => {
      const idx = this.availableWidgets.findIndex((c) => c.type === this.selectedWidget?.type);
      if (idx > -1) {
        this.widgetListItems
          .get(idx)
          .nativeElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.groupFieldsSub$) {
      this.groupFieldsSub$.unsubscribe();
    }
  }

  private async findDatasourceFields(fieldType?: string | string[]) {
    if (!this.ds) {
      this.dsMetadataFields = [];
      return;
    }

    const fieldNames = await this.customFieldService.getMetadataSubTypesAsync(this.ds);
    this.dsMetadataFields = this.accountMetadataFields
      .filter((f) => fieldNames.includes(f.fieldName))
      .map((f) => {
        for (const axis of ['primary', 'secondary']) {
          if (
            f.fieldName === this.breakDownOptions[axis]?.numericMetadataFieldId &&
            f.metadata?.calculationType === 'binary'
          ) {
            this.breakDownOptions[axis].isMetadataBinary = true;
          }
        }
        return {
          name: f.fieldName,
          label: f.description,
          type: f.fieldType,
          isRating: f.metadata?.rating === true,
          isRedacted: f.metadata?.redacted === true,
          aliasedFields: f.aliasedFields,
          isDisplayed: f.metadata?.display !== false,
          calculationFieldType: f.metadata?.calculationFieldType,
          calculationType: f.metadata?.calculationType,
        };
      });
    if (fieldType) {
      this.dsMetadataFields = this.dsMetadataFields.filter((f) => {
        if (typeof fieldType === 'string') {
          if (fieldType === 'rating') {
            return f.isRating;
          }
          return f.type === fieldType || f.calculationFieldType === fieldType;
        }

        const fieldTypeMatches =
          fieldType.includes(f.type) || fieldType.includes(f.calculationFieldType);
        if (fieldType.includes('rating')) {
          return f.isRating || fieldTypeMatches;
        }
        return fieldTypeMatches;
      });
    }

    this.dsMetadataFields.sort((f1, f2) =>
      f1.label.localeCompare(f2.label, undefined, { sensitivity: 'accent' })
    );
  }

  public get widgetTitle() {
    return WidgetUtility.getWidgetTitle(this.widget, {
      skipVolumeVsSentimentSelectedItem: true,
      selectedItemName: this.widget.payload.selectedItems[0],
    });
  }

  selectWidget(widgetType) {
    this.selectedWidget = widgetType;
    if (!widgetType.customItems) {
      this.itemsToDisplay = 'top';
    }

    if (this.widget?.payload.type === 'predictor' && widgetType.type !== 'predictor') {
      this.ds = this.widgetEditOptions.dashboardDataSource;
    }

    if (this.widget?.payload.type !== 'predictor' && widgetType.type === 'predictor') {
      this.ds = this.widgetEditOptions.dashboardKeyDriverDataSource;
    }

    const payload: any = {};
    if (widgetType.type === 'impact') {
      payload.entityTypeFilter = this.analyticItems[this.TOPIC_SUB_TYPES_LABEL].subTypes
        .sort()
        .join();
    }

    if (widgetType.type === 'focusAreas') {
      payload.entityTypeFilter = 'Leaf Nodes';
    }

    this.widget = this.widgetService.createWidget(
      widgetType.type,
      this.widgetEditOptions.dashboard,
      this.ds?.id,
      widgetType.overTime,
      payload
    );

    if (this.ds) {
      const dsValidity = DashboardValidityChecks.dataSourceValidCheck(
        this.widget,
        undefined,
        this.ds,
        this.accountMetadataFields,
        true,
        this.data.dashboard
      );
      if (dsValidity.disabled) {
        this.ds = undefined;
      }
    }
  }

  public makeWidget() {
    switch (this.selectedWidget.type) {
      case 'documentCount':
      case 'sentimentScore':
      case 'scatterPlot':
      case 'sentimentPolarity':
      case 'wordcloud':
      case 'topMovers':
      case 'crosstab':
      case 'powerScore':
      case 'powerScoreOverTime':
      case 'documents':
      case 'insightFeed':
        this.updateStateForItemsToDisplay();
        break;
      case 'sentimentVolume':
        this.canSelectMultiple = false;
        this.changeState('item-picker');
        this.updateSectionSelectorAvailability(true);
        break;
      case 'numericMetadata':
        this.canSelectMultiple = false;
        this.changeState('metadata-picker', ['double', 'long']);
        break;
      case 'sentimentAccuracy':
        this.canSelectMultiple = false;
        this.changeState('metadata-picker', 'keyword');
        break;
      case 'featureScoring':
        this.updateStateForItemsToDisplay();
        this.updateAnalyticItems({ target: { value: '' } });
        if (this.itemsToDisplay !== 'custom') {
          this.canSelectMultiple = false;
          this.changeState('metadata-picker', 'keyword');
        }
        break;
      case 'donut':
        this.changeState('metadata-picker', ['long']);
        break;
      case 'gauge':
        this.changeState('metadata-picker', ['rating']);
        break;
      case 'breakdown':
        this.changeState('metadata-picker', ['double', 'long', 'keyword']);
        this.setBreakdownFields();
        this.updateSectionSelectorAvailability(true);
        break;
    }

    if (this.state === 'start') {
      this.confirm();
    }
  }

  public async changeState(state: StateType, metadataType?: string | string[]) {
    if (this.state === state) {
      return;
    }
    this.state = state;
    if (state === 'item-picker') {
      setTimeout(() => {
        if (this.datasourceChooser) {
          this.elementItemTypeInputElement.open();
        }
      });
    } else if (state === 'metadata-picker') {
      this.customFieldSelected = true;
      if (metadataType) {
        await this.findDatasourceFields(metadataType);
      }
    }
  }

  public updateStateForItemsToDisplay() {
    if (this.itemsToDisplay === 'custom') {
      this.canSelectMultiple = true;
      this.widget.payload.limit = -1;
      if (this.widget.payload.type !== 'featureScoring') {
        this.analyticItem = '';
      }
      if (this.widget.payload.type === 'crosstab') {
        this.widget.payload.columnAnalyticItem = '';
      }
      this.changeState('item-picker');
      this.updateSectionSelectorAvailability(true);
      return;
    }

    this.widget.payload.limit = 20;
    if (!this.ds?.isSocial && this.widget.payload.type !== 'featureScoring') {
      this.analyticItem = this.getDefaultTopAnalyticItem();
      if (this.widget.payload.type === 'crosstab') {
        this.widget.payload.columnAnalyticItem = this.analyticItem;
      }
    }
    if (this.ds?.isSocial && this.widget.component !== 'DashboardWidgetBigNumberComponent') {
      this.analyticItem = 'entities';
    }
  }

  private getDefaultTopAnalyticItem(): string {
    if (!this.ds || this.ds.hasPhrases) {
      return 'phrases';
    }
    if (this.ds.hasTopics) {
      return 'topics';
    }
    if (this.ds.hasEntities) {
      return 'entities';
    }
    if (this.ds.hasThemes) {
      return 'themes';
    }
    if (this.ds.hasTaxonomy) {
      return 'taxonomy';
    }
    return 'phrases';
  }

  public async selectDatasource(item: WidgetDataSource) {
    this.ds = item;
    await this.findDatasourceFields();

    this.analyticItems = await this.prepareAnalyticItems();
    this.analyticItemTypeKeys = Object.keys(this.analyticItems);

    if (this.widget.payload.type !== 'impact') {
      this.entityTypeFilter = null;
    }

    this.customFieldSelected = false;
    this.standardFieldSelected = false;

    if (this.widget?.payload.type === 'breakdown') {
      this.widget.payload.selectedSection = undefined;
      this.sectionSelectionText = undefined;
      this.setBreakdownFields();
      this.updateSectionSelectorAvailability();
    }

    if (this.ds.isSocial) {
      this.itemsToDisplay = 'top';
    }
  }

  private async loadSectionMetadata(): Promise<void> {
    const loadId = ++this.sectionMetadataLoadId;
    this.sectionMetadata = [];
    this.isSectionMetadataLoaded = false;

    if (!this.ds?.hasSections) {
      return;
    }

    try {
      const allMetadata = await this.sectionService.loadAllSectionMetadata(
        this.dashboard.project_id,
        this.ds
      );

      if (loadId !== this.sectionMetadataLoadId) {
        return;
      }
      this.sectionMetadata.push(...allMetadata);
      this.setBreakdownFields();
    } catch (error) {
      this.logger.error(translate('widgets.analytic-item-selector.failed-to-load-sections'), {
        error,
      });
    } finally {
      if (loadId === this.sectionMetadataLoadId) {
        this.isSectionMetadataLoaded = true;
      }
    }
  }

  onBreakdownSectionSelected(selectedSection?: SelectedSection[]): void {
    this.widget.payload.selectedSection = selectedSection;
    this.sectionSelectionText = undefined;
    if (!SectionService.isSelectionComplete(selectedSection)) {
      this.sectionSelectionText = translate('widgets.analytic-item-selector.must-select-section');
    }
  }

  private updateSectionSelectorAvailability(clearSelection: boolean = false): void {
    const isBreakdown = this.widget?.payload.type === 'breakdown';
    const sectionSelectorEnabled = this.state === 'item-picker' || isBreakdown;

    if (!sectionSelectorEnabled) {
      return;
    }

    let resolvedAnalyticItem = this.analyticItem;
    if (this.isSubtypeSelected(this.analyticItem, this.ENTITY_SUB_TYPES_LABEL)) {
      resolvedAnalyticItem = 'entities';
    } else if (this.isSubtypeSelected(this.analyticItem, this.TOPIC_SUB_TYPES_LABEL)) {
      resolvedAnalyticItem = 'topics';
    }

    const sectionSelectorAvailable =
      this.ds?.hasSections &&
      ((!isBreakdown &&
        FilterUtils.isSectionSelectorAvailable(resolvedAnalyticItem, this.analyticItem)) ||
        this.sectionPropertySelected);
    if (!sectionSelectorAvailable) {
      this.sectionMetadata = [];
      this.isSectionMetadataLoaded = false;
      this.sectionSelectionText = undefined;
      this.widget.payload.selectedSection = undefined;
      return;
    }
    // Clear payload section selection and reload section metadata when the user changes the state.
    if (clearSelection) {
      this.widget.payload.selectedSection = undefined;
    }

    // Trigger a metadata refresh so the selector reflects the current datasource/axis state.
    if (!this.isSectionMetadataLoaded) {
      this.loadSectionMetadata();
    }
  }

  onItemPickerSectionSelected(selectedSection?: SelectedSection[]): void {
    this.widget.payload.selectedSection = selectedSection;
    this.handleAnalyticItemChange(this.analyticItem);
  }

  private disableAvailableWidgetsBasedOnOptions() {
    if (!this.datasourceManagerStore.hasData()) {
      this.availableWidgets
        .filter((w) => w.type !== 'note' && w.type !== 'noteMarkdown' && w.type !== 'insightFeed')
        .forEach((w) => {
          w.disabled = true;
          w.tooltip = translate('widgets.widget-add.no-data-source');
        });
      return;
    }

    if (this.widgetEditOptions.dashboard.payload.sentimentScale === 5) {
      const sentimentAccuracyWidget = this.availableWidgets.find(
        (w) => w.type === 'sentimentAccuracy'
      );
      sentimentAccuracyWidget.disabled = true;
      sentimentAccuracyWidget.tooltip = translate('widgets.not-supported-5-point-dashboard');
    }

    if (!this.widgetEditOptions.dashboardKeyDriverDataSource) {
      const predictorWidget = this.availableWidgets.find((w) => w.type === 'predictor');
      predictorWidget.disabled = true;
      predictorWidget.tooltip = translate('widgets.widget-add.no-key-driver-analysis');
    }

    const hasJourneyGroup = this.datasourceManagerStore
      .entities()
      .some((ds) => ds.isJourneyGroup && ds.hasDateData);
    if (!hasJourneyGroup) {
      const journeyWidget = this.availableWidgets.find((w) => w.type === 'journey');
      journeyWidget.disabled = true;
      journeyWidget.tooltip = translate('widgets.widget-add.no-journey-group-available');
    }
  }

  get canConfirm() {
    if (!this.selectedWidget) {
      return false;
    }

    if (!this.ds && !this.isNoteWidgetSelected && !this.isInsightFeedWidgetSelected) {
      return false;
    }

    return true;
  }

  public get confirmButtonText(): string {
    if (this.data.widget) {
      return translate('widgets.widget-add.save');
    }
    if (
      this.state === 'start' &&
      (this.itemsToDisplay === 'custom' || this.selectedWidget.isMultiStep)
    ) {
      if (this.widget.payload.type === 'impact' || this.widget.payload.type === 'focusAreas') {
        return translate('widgets.widget-add.select-rating-field');
      }
      return translate('widgets.widget-add.select-custom-items');
    }
    return translate('widgets.widget-add.create');
  }

  get canConfirmMetadata(): boolean {
    switch (this.widget.payload.type) {
      case 'numericMetadata':
        return this.isNmotFieldSelectorValid;
      case 'breakdown':
        const getIsValidBox = (opts: Partial<WidgetAddBreakdownAxisOption>) => {
          return (
            opts.scoring === 'box' &&
            (opts.boxScoringDisplayData.isTopShown ||
              opts.boxScoringDisplayData.isNeutralShown ||
              opts.boxScoringDisplayData.isBottomShown) &&
            opts.min < opts.max
          );
        };

        const getIsValidNps = (opts: Partial<WidgetAddBreakdownAxisOption>) => {
          return opts.scoring === 'nps' && opts.min < opts.max;
        };

        const getIsValidBucket = (axis: BreakdownAxisKey): boolean => {
          return !this.bucketValidationError[axis];
        };

        const getIsValidOther = (opts: Partial<WidgetAddBreakdownAxisOption>) => {
          return opts.scoring !== 'box' && opts.scoring !== 'nps' && opts.scoring !== 'bucket';
        };

        const isValidBoxPrimary = getIsValidBox(this.breakDownOptions.primary);
        const isValidNpsPrimary = getIsValidNps(this.breakDownOptions.primary);
        const isValidOtherPrimary = getIsValidOther(this.breakDownOptions.primary);
        const isValidBucketPrimary =
          this.breakDownOptions.primary.scoring === 'bucket' && getIsValidBucket('primary');
        const isPrimaryValid =
          this.breakdownField &&
          (isValidBoxPrimary || isValidNpsPrimary || isValidBucketPrimary || isValidOtherPrimary);

        if (
          this.widget.payload.selectedSection?.some(
            (sec) => !sec.field || !Array.isArray(sec.buckets) || sec.buckets.length === 0
          )
        ) {
          return false;
        }

        if (this.breakdownSecondaryAxisAdded) {
          const isValidBoxSecondary = getIsValidBox(this.breakDownOptions.secondary);
          const isValidNpsSecondary = getIsValidNps(this.breakDownOptions.secondary);
          const isValidOtherSecondary = getIsValidOther(this.breakDownOptions.secondary);
          const isValidBucketSecondary =
            this.breakDownOptions.secondary.scoring === 'bucket' && getIsValidBucket('secondary');
          return (
            isPrimaryValid &&
            !!this.breakDownOptions.secondary?.numericMetadataFieldId &&
            !!this.breakDownOptions.secondary?.scoring &&
            (isValidBoxSecondary ||
              isValidNpsSecondary ||
              isValidBucketSecondary ||
              isValidOtherSecondary)
          );
        }
        return isPrimaryValid;
      default:
        return !!this.metadataField;
    }
  }

  get metadataPickerTitle(): string {
    switch (this.widget.payload.type) {
      case 'numericMetadata':
        return translate('widgets.widget-add.numeric-metadata-over-time');
      case 'breakdown':
        return translate('widgets.widget-add.breakdown');
      case 'donut':
        return translate('widgets.widget-add.select-metadata-for-donut');
      case 'gauge':
        return translate('widgets.widget-add.select-metadata-for-gauge');
      default:
        return translate('widgets.widget-add.select-metadata-for', { widget: this.widgetTitle });
    }
  }

  public updateAnalyticItems($event) {
    if (!this.analyticItem) {
      return;
    }
    this.selectedItem = $event.target.value;
    clearTimeout(this.selectedItemAc.timeout);
    this.selectedItemAc.timeout = setTimeout(async () => {
      this.selectedItemAc.inProgress = true;
      this.selectedItemAc.results = await this.getAnalyticItems(this.selectedItem);
      this.selectedItemAc.filteredResults = [...this.selectedItemAc.results];
      this.selectedItemAc.timeout = null;
      this.selectedItemAc.inProgress = false;
    }, 400);
  }

  public get searchPlaceholder(): string {
    let translatedItem = this.analyticItem;
    if (!translatedItem) {
      return translate('widgets.widget-add.select-itemtype-first');
    }

    if (this.customFieldSelected || this.standardFieldSelected) {
      translatedItem = FieldService.getFieldLongName(translatedItem);
    } else if (this.isSubtypeSelected(this.analyticItem, this.TOPIC_SUB_TYPES_LABEL)) {
      translatedItem = translate(
        `analytic-items.topics-subtypes.${translatedItem.toLocaleLowerCase()}`
      );
    }

    return translate('widgets.widget-add.search-for', {
      item: translatedItem.toLocaleLowerCase(),
    });
  }

  public isAnalyticTypeEnabled(key: string, analyticItemType: string) {
    if (key === this.ENTITY_SUB_TYPES_LABEL) {
      analyticItemType = 'entities';
    } else if (key === this.TOPIC_SUB_TYPES_LABEL) {
      analyticItemType = 'topics';
    } else if (key === 'Custom Fields' && analyticItemType.startsWith('a_')) {
      const field = this.dsMetadataFields.find((f) => f.name === analyticItemType);
      analyticItemType = field.name;
    }

    const isFloatMetadataType = (fieldName) => {
      if (
        this.widget.payload.type !== 'bigNumber' &&
        this.widget.payload.type !== 'numericMetadata' &&
        key === this.CUSTOM_FIELD_LABEL
      ) {
        return this.floatMetadataFieldNames.includes(fieldName);
      }
    };

    return (
      !isFloatMetadataType(analyticItemType) &&
      DashboardValidityChecks.dataSourceHasValuesFor(this.ds, analyticItemType)
    );
  }
  private isSubtypeSelected(subtype, subLabel) {
    if (
      this.analyticItems[subLabel] &&
      this.analyticItems[subLabel].subTypes &&
      this.analyticItems[subLabel].subTypes.includes(subtype)
    ) {
      return true;
    }
  }

  public handleAnalyticItemChange(item: string) {
    if (item !== this.analyticItem) {
      this.selectedItems = [];
      this.selectedItemAc.results = [];
      this.selectedItemAc.filteredResults = [];
      this.isBlankChecked = false;
      this.blankCount = 0;
      delete this.widget.payload.showBlanks;
    }

    this.analyticItem = item;
    this.entityTypeFilter = null;
    this.customFieldSelected = false;
    this.standardFieldSelected = false;

    if (
      this.isSubtypeSelected(item, this.ENTITY_SUB_TYPES_LABEL) ||
      this.isSubtypeSelected(item, this.TOPIC_SUB_TYPES_LABEL)
    ) {
      this.entityTypeFilter = item;
    }

    if (
      this.analyticItems[this.CUSTOM_FIELD_LABEL] &&
      this.analyticItems[this.CUSTOM_FIELD_LABEL].subTypes &&
      this.analyticItems[this.CUSTOM_FIELD_LABEL].subTypes.includes(item)
    ) {
      this.customFieldSelected = true;
    }

    if (
      this.analyticItems[this.STANDARD_FIELD_LABEL] &&
      this.analyticItems[this.STANDARD_FIELD_LABEL].subTypes &&
      this.analyticItems[this.STANDARD_FIELD_LABEL].subTypes.includes(item)
    ) {
      this.standardFieldSelected = true;
    }

    if (this.analyticItem !== 'taxonomy') {
      this.updateAnalyticItems({ target: { value: this.selectedItem } });
    }

    this.updateSectionSelectorAvailability();
  }

  public addSelectedItem(item: string) {
    this.elementItemInputElement.nativeElement.value = this.selectedItem;

    if (this.canSelectMultiple) {
      const idx = this.selectedItems.findIndex((i) => i === item);
      if (idx === -1) {
        this.selectedItems.push(item);
        this.selectedItemAc.filteredResults = this.selectedItemAc.filteredResults.filter(
          (ac) => ac.key !== item
        );
      }
    } else {
      this.selectedItems = [item];
      this.selectedItemAc.filteredResults = this.selectedItemAc.results.filter(
        (ac) => ac.key !== item
      );
    }

    if (item === '') {
      this.widget.payload.showBlanks = true;
    }

    this.elementItemInputElement.nativeElement.blur();
  }

  public removeSelectedItem(item: string) {
    const index = this.selectedItems.findIndex((i) => item === i);
    if (index !== -1) {
      this.selectedItems.splice(index, 1);
    }

    if (item === '') {
      this.isBlankChecked = false;
      delete this.widget.payload.showBlanks;
      return;
    }

    this.updateAnalyticItems({ target: { value: '' } });
  }

  public get isItemSelected(): boolean {
    return !!this.metadataField && this.selectedItems.length > 0;
  }

  get canConfirmCustomItems(): boolean {
    if (this.selectedItems.every((item) => !item)) {
      return false;
    }

    let ret = this.isItemSelected;
    if (this.widget.payload.type === 'crosstab') {
      ret = ret && !!this.otherAnalyticItem && this.otherSelectedItems.length > 0;
    }

    return ret;
  }

  public get dashboard(): Dashboard {
    return this.data.dashboard;
  }

  public cancel(): void {
    this.modalClosed.emit(null);
  }

  public async back() {
    this.selectedItems.splice(0, this.selectedItems.length);
    if (this.widget.payload.type !== 'impact') {
      this.analyticItem = undefined;
    }
    this.entityTypeFilter = null;
    this.customFieldSelected = false;
    this.standardFieldSelected = false;

    await this.findDatasourceFields();
    this.state = 'start';
  }

  public confirm(): void {
    if (this.widget.payload.showBlanks) {
      this.widget.payload.selectedItems = this.widget.payload.selectedItems.filter(
        (item) => item !== ''
      );
    }

    //Since we're using the same selector for the subtype and the main type we
    //need to set it to the proper feature at the end.
    //TODO: a better design after v1 would be a separate dropdown for subtypes.
    //That would get rid of much of the "interesting" design choices here.
    if (this.isSubtypeSelected(this.analyticItem, this.ENTITY_SUB_TYPES_LABEL)) {
      this.analyticItem = 'entities';
    } else if (this.isSubtypeSelected(this.analyticItem, this.TOPIC_SUB_TYPES_LABEL)) {
      this.analyticItem = 'topics';
    }

    if (this.otherAnalyticItem) {
      if (this.isSubtypeSelected(this.otherAnalyticItem, this.ENTITY_SUB_TYPES_LABEL)) {
        this.otherAnalyticItem = 'entities';
      } else if (this.isSubtypeSelected(this.otherAnalyticItem, this.TOPIC_SUB_TYPES_LABEL)) {
        this.otherAnalyticItem = 'topics';
      }
    }

    if (this.widget.payload.type === 'numericMetadata') {
      this.widget.payload.numericMetadataFields = this.numericMetadataFields;
    } else if (this.widget.payload.type === 'breakdown') {
      if (this.widget.payload.breakdownOptions?.scoring !== this.breakDownOptions.primary.scoring) {
        delete this.widget.payload.sort;
      }

      this.widget.payload.breakdownOptions = {
        fieldId: this.breakdownField,
        numericMetadataFieldId: this.breakDownOptions.primary.numericMetadataFieldId,
        scoring: this.breakDownOptions.primary.scoring,
      };
      delete this.widget.payload.additionalBreakdownOptions;
      this.breakdownSecondaryAxisAdded =
        !!this.breakDownOptions.secondary.numericMetadataFieldId &&
        !!this.breakDownOptions.secondary.scoring;
      if (this.breakdownSecondaryAxisAdded) {
        this.widget.payload.additionalBreakdownOptions = {};
      }
      const assignSetupToWidgetPayload = (option: Partial<WidgetAddBreakdownAxisOption>) => {
        const target = {};
        for (const key of Object.keys(option)) {
          if (key === 'scoringSet') {
            continue;
          }
          if (key === 'fieldBuckets' && option[key]) {
            target[key] = (option.fieldBuckets ?? []).map((bucket) => ({
              ...bucket,
              minimumValue: this.coerceToNumber(bucket.minimumValue),
              maximumValue: this.coerceToNumber(bucket.maximumValue),
              includeMinimum: !!bucket.includeMinimum,
              includeMaximum: !!bucket.includeMaximum,
              bucketName: bucket.bucketName ?? '',
            }));
            continue;
          }
          if (key === 'boxScoringDisplayData' && option[key]) {
            for (const boxKey of Object.keys(option[key])) {
              target[boxKey] = option[key][boxKey];
            }
          } else {
            target[key] = option[key];
          }
        }
        return target;
      };

      for (const key of ['breakdownOptions', 'additionalBreakdownOptions']) {
        if (!this.widget.payload[key]) {
          continue;
        }
        const breakdownOptionKey = key === 'breakdownOptions' ? 'primary' : 'secondary';
        const payloadObject = assignSetupToWidgetPayload(this.breakDownOptions[breakdownOptionKey]);
        this.widget.payload[key] = { ...this.widget.payload[key], ...payloadObject };
      }
      const { breakdownOptions, additionalBreakdownOptions } = this.widget.payload;

      this.widget.payload.hasSecondaryAxis =
        this.breakdownSecondaryAxisAdded &&
        breakdownOptions.scoring !== additionalBreakdownOptions.scoring;

      this.widget.payload.analyticItem = this.breakdownField;
      this.widget.payload.customFieldSelected = false;
      this.widget.payload.standardFieldSelected = false;
      this.widget.payload.sectionPropertySelected = this.breakdownField?.startsWith(
        Constants.SECTION_PROPERTIES_PREFIX
      );
      if (!this.widget.payload.sectionPropertySelected) {
        this.widget.payload.customFieldSelected = FieldService.isCustomField(this.breakdownField);
        this.widget.payload.standardFieldSelected = !this.widget.payload.customFieldSelected;
      }
    }
    if (this.widget.payload.type === 'predictor') {
      this.widget.x = 0;
      this.widget.y = 0;
      this.widget.cols = 12;
      this.widget.rows = 9;
      this.widget.title = '';
      this.widget.payload.selectedBreakdown = 'All';
    }

    if (this.widget.payload.type === 'impact') {
      this.widget.payload.scoringStrategy = Constants.TWTRA_DEFAULT_SCORING_STRATEGY;
      this.widget.payload.ratingScale = Constants.TWTRA_DEFAULT_DRIVERS_RANGE;
    }

    if (this.widget.payload.type === 'focusAreas') {
      this.widget.payload.scoringStrategy = Constants.TWTRA_DEFAULT_SCORING_STRATEGY;
      this.widget.payload.ratingScale = Constants.TWTRA_DEFAULT_DRIVERS_RANGE;
      if (this.ds) {
        if (this.ds.hasTaxonomy) {
          this.widget.payload.analyticItem = 'taxonomy';
          this.widget.payload.entityTypeFilter = 'Leaf Nodes';
        }
      }
    }

    this.widget.dataSourceId = this.ds?.id;
    if (this.isNoteWidgetSelected) {
      this.widget.payload.text = this.note.text;
      this.widget.payload.hideTitle = !this.note.displayTitle;
      delete this.widget.dataSourceId;
    }

    if (this.isInsightFeedWidgetSelected) {
      delete this.widget.dataSourceId;
    }

    this.modalClosed.emit(this.widget);
  }

  private async getAnalyticItems(term: string): Promise<AnalyticItem[]> {
    let feature = this.analyticItem;
    let entityType = this.entityTypeFilter;

    const setFeatureWithSubtype = (featureName, subLabel) => {
      if (
        this.analyticItems[subLabel] &&
        this.analyticItems[subLabel].subTypes &&
        this.analyticItems[subLabel].subTypes.includes(this.analyticItem)
      ) {
        feature = featureName;
        entityType = this.analyticItem;
      }
    };

    setFeatureWithSubtype('entities', this.ENTITY_SUB_TYPES_LABEL);
    setFeatureWithSubtype('topics', this.TOPIC_SUB_TYPES_LABEL);

    this.isCustomDateSelected = false;
    this.isCustomDoubleSelected = false;

    if (this.customFieldSelected) {
      const selectedMetadataType = this.dsMetadataFields.find(
        (f) => f.name === this.analyticItem
      )?.type;
      this.isCustomDateSelected = selectedMetadataType === 'date';
      this.isCustomDoubleSelected = selectedMetadataType === 'double';
      this.isCustomLongSelected = selectedMetadataType === 'long';
    }

    let report: { items: { count: { [key: string]: number } } };

    if (feature === 'tags') {
      const tagsReport: { title: string; count: number }[] = [];
      if (this.ds.groupId) {
        const analyses = this.ds.groupAnalyses.length;

        for (let i = 0; i < analyses; i++) {
          tagsReport.push(
            ...(await this.tagCacheService.getTagsImmediate(
              this.ds.groupCollections[i],
              this.ds.groupAnalyses[i],
              this.dashboard.project_id,
              term
            ))
          );
        }
      } else {
        tagsReport.push(
          ...(await this.tagCacheService.getTagsImmediate(
            this.ds.collectionName,
            this.ds.analysisId,
            this.dashboard.project_id,
            term
          ))
        );
      }

      const reportItemsCount = {};
      tagsReport.forEach((item) => (reportItemsCount[item.title] = item.count));

      report = {
        items: {
          count: reportItemsCount,
        },
      };
    } else {
      const widgetQueryOptions = this.filterService.getWidgetQueryOptions(
        this.widget,
        this.ds,
        this.widgetGroup,
        this.comparison?.filters[0]
      );
      const filterQuery = this.filterService.getQueryForDocuments(widgetQueryOptions, false, true);

      if (this.canShowBlank) {
        let collectionId;
        let analysisGroupId;
        switch (this.ds.type) {
          case 'analysis':
            collectionId = this.ds.collectionName;
            break;
          case 'group':
            analysisGroupId = this.ds.groupId;
            break;
        }

        const calculations = await this.fieldStatisticsService.getStatsForCollection(
          this.dashboard.project_id,
          collectionId,
          analysisGroupId,
          'xxx',
          feature,
          undefined,
          filterQuery,
          this.timezoneService.timezone
        );
        this.blankCount = calculations.custom[feature]?.missing ?? 0;
      }

      let reportName = 'analyticItems';
      const reportParams: any = {
        analysisName: this.ds.analysisId,
        featureName: feature,
        featurePrefix: term,
        featureSectionFilter: FilterUtils.convertSelectedSectionToFeatureSectionFilter(
          this.widget.payload.selectedSection
        ),
        entityTypeFilter: entityType,
      };
      if (FieldService.isStandardField(feature)) {
        reportName = 'metadataTopFeatures';
        reportParams.standardField = feature;
      }

      if (this.ds.isSocial) {
        reportParams.isSocial = true;
      }

      report = <Report<any>>(
        await this.reportService.getReport(
          this.ds.collectionName,
          this.ds.groupId,
          reportName,
          reportParams,
          'json',
          filterQuery,
          null,
          null,
          this.dashboard.project_id
        )
      );

      if (!report.items || !report.items.count) {
        return [];
      }
    }

    const result = [];
    for (const key of Object.getOwnPropertyNames(report.items.count)) {
      if (this.selectedItems.indexOf(key) === -1) {
        const count = report.items.count[key];
        const title = this.formatItemLabel(key, true);

        result.push({ key, count, title });
      }
    }
    if (!term) {
      result.sort((a, b) => b.count - a.count);
    } else {
      result.sort((a, b) => {
        let c = 0;
        if (b.key > a.key) {
          c = -1;
        } else if (a.key > b.key) {
          c = 1;
        }
        return c;
      });
    }
    return result;
  }

  formatItemLabel(key: string, unescapeHtml?: boolean) {
    if (this.isCustomDateSelected) {
      return this.lexDatePipe.transform(key);
    }
    if (this.isCustomDoubleSelected) {
      return formatNumber(+key, 2);
    }
    if (key === '') {
      let blankStr = '&lt;blank&gt;';
      if (unescapeHtml) {
        blankStr = Utils.unescapeHtml(blankStr);
      }
      return blankStr;
    }
    return key;
  }

  private async prepareAnalyticItems(): Promise<AnalyticItemTypeMap> {
    const metadataFields = await this.fieldService.getFields();

    this.floatMetadataFieldNames = metadataFields.items
      .filter((f) => f.fieldType === 'double')
      .map((f) => f.fieldName);

    const preparedItems = {};
    preparedItems[this.DEFAULT_LABEL] = {
      analyticItem: 'defaults',
      displayName: translate('widgets.widget-add.defaults'),
      subTypes: ['topics', 'themes', 'phrases', 'categories', 'entities', 'taxonomy'],
    };
    if (!this.ds) {
      return preparedItems;
    }
    const itemValues = await AnalyticItemTypes.generateMapFromDataSource(
      this.ds,
      this.accountService,
      this.customFieldService
    );
    if (itemValues['entities'].subTypes.length > 0) {
      preparedItems[this.ENTITY_SUB_TYPES_LABEL] = itemValues['entities'];
    }
    if (itemValues['topics'].subTypes.length > 0) {
      preparedItems[this.TOPIC_SUB_TYPES_LABEL] = itemValues['topics'];
    }
    if (itemValues['metadata'].subTypes?.length > 0) {
      preparedItems[this.CUSTOM_FIELD_LABEL] = itemValues['metadata'];
      preparedItems[this.CUSTOM_FIELD_LABEL].subTypes = preparedItems[
        this.CUSTOM_FIELD_LABEL
      ].subTypes.filter((e) => FieldService.isVisible(e));
      if (preparedItems[this.CUSTOM_FIELD_LABEL].subTypes.length === 0) {
        delete preparedItems[this.CUSTOM_FIELD_LABEL];
      }
    }
    if (itemValues['standardFields'].subTypes.length > 0) {
      preparedItems[this.STANDARD_FIELD_LABEL] = itemValues['standardFields'];
      preparedItems[this.STANDARD_FIELD_LABEL].subTypes = preparedItems[
        this.STANDARD_FIELD_LABEL
      ].subTypes.filter((e) => e !== 'title');
      if (preparedItems[this.STANDARD_FIELD_LABEL].subTypes.length === 0) {
        delete preparedItems[this.STANDARD_FIELD_LABEL];
      }
    }
    return preparedItems;
  }

  get isSentimentReport() {
    return (
      this.widget &&
      ['sentimentScore', 'sentimentPolarity', 'sentimentVolume', 'wordcloud'].includes(
        this.widget.payload.type
      )
    );
  }

  onAxisChanged(isColumn: boolean) {
    this.selectedAxis = isColumn ? 'column' : 'row';
    this.updateAnalyticItems({ target: { value: '' } });
  }

  onTaxonomySelectionChanged($event) {
    this.selectedItems = $event.map((t) => t.id);
  }

  get analyticItem(): string {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.analyticItem;
    }
    return this.widget.payload.columnAnalyticItem;
  }

  set analyticItem(item) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.analyticItem = item;
    } else {
      this.widget.payload.columnAnalyticItem = item;
    }
  }

  get otherAnalyticItem(): string {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.columnAnalyticItem;
    }
    return this.widget.payload.analyticItem;
  }

  set otherAnalyticItem(item) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.columnAnalyticItem = item;
    } else {
      this.widget.payload.analyticItem = item;
    }
  }

  get selectedItems(): string[] {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.selectedItems;
    }
    return this.widget.payload.columnSelectedItems;
  }

  get originalSelectedItems(): string[] {
    if (this.selectedAxis === 'row') {
      return this.originalRowItems;
    }
    return this.originalColumnItems;
  }

  set selectedItems(items) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.selectedItems = items;
    } else {
      this.widget.payload.columnSelectedItems = items;
    }
  }

  get otherSelectedItems(): string[] {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.columnSelectedItems;
    }
    return this.widget.payload.selectedItems;
  }

  get entityTypeFilter() {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.entityTypeFilter;
    }
    return this.widget.payload.columnEntityTypeFilter;
  }

  set entityTypeFilter(filter: string) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.entityTypeFilter = filter;
    } else {
      this.widget.payload.columnEntityTypeFilter = filter;
    }
  }

  get customFieldSelected() {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.customFieldSelected;
    }
    return this.widget.payload.columnCustomFieldSelected;
  }

  set customFieldSelected(val) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.customFieldSelected = val;
    } else {
      this.widget.payload.columnCustomFieldSelected = val;
    }
  }

  get sectionPropertySelected() {
    return this.widget.payload.sectionPropertySelected;
  }

  set sectionPropertySelected(val) {
    this.widget.payload.sectionPropertySelected = val;
  }

  get standardFieldSelected() {
    if (this.selectedAxis === 'row') {
      return this.widget.payload.standardFieldSelected;
    }
    return this.widget.payload.columnStandardFieldSelected;
  }

  set standardFieldSelected(val) {
    if (this.selectedAxis === 'row') {
      this.widget.payload.standardFieldSelected = val;
    } else {
      this.widget.payload.columnStandardFieldSelected = val;
    }
  }

  get metadataField(): string {
    switch (this.widget.payload.type) {
      case 'featureScoring':
        return this.widget.payload.mostCommonItem;
      case 'sentimentAccuracy':
        return this.widget.payload.sentimentField;
      default:
        return this.analyticItem;
    }
  }

  set metadataField(field: string) {
    switch (this.widget.payload.type) {
      case 'featureScoring':
        this.widget.payload.mostCommonItem = field;
        break;
      case 'sentimentAccuracy':
        this.widget.payload.sentimentField = field;
        break;
      default:
        this.analyticItem = field;
        break;
    }
  }

  labelFor(analyticItem, key) {
    if (analyticItem === this.CUSTOM_FIELD_LABEL) {
      return FieldService.getFieldLongName(key);
    }
    if (analyticItem === this.DEFAULT_LABEL) {
      return translate(`analytic-items.${key}`);
    }
    if (analyticItem === this.TOPIC_SUB_TYPES_LABEL) {
      return translate(`analytic-items.topics-subtypes.${key.toLocaleLowerCase()}`);
    }
    return key;
  }

  getItemToolTip(analyticItem) {
    if (analyticItem === 'taxonomy') {
      if (!this.ds.hasTaxonomy || this.ds.sourceVersion < 7) {
        return translate('widgets.widget-add.reanalize-data-for-taxonomy');
      }
      return '';
    }
    return '';
  }

  getFieldLabel(s: string): string {
    return FieldService.getFieldLongName(s);
  }

  public toggleBlank(checked: boolean): void {
    this.isBlankChecked = checked;
    if (checked) {
      this.addSelectedItem('');
    } else {
      this.removeSelectedItem('');
    }
  }

  onNewspaperToggled(isToggled) {
    this.widget.payload.newspaper = this.widget.payload.newspaper || {};
    this.widget.payload.newspaper.show = isToggled;
    this.widget.cols = isToggled ? 9 : 6;
    this.widget.payload.newspaper.scene = isToggled ? this.newspaperProperties.scene : undefined;
  }

  onNumericMetadataFieldsChanged(fields: NumericMetadataField[]): void {
    this.numericMetadataFields = fields;
  }

  onNumericMetadataFieldsIsValid(isValid: boolean): void {
    this.isNmotFieldSelectorValid = isValid;
  }

  onBreakdownBreakdownFieldChange(event: any) {
    this.breakdownField = event.detail.selected.id;
    this.sectionPropertySelected = this.breakdownField?.startsWith(
      Constants.SECTION_PROPERTIES_PREFIX
    );
    this.updateSectionSelectorAvailability();
    if (this.sectionPropertySelected) {
      this.customFieldSelected = false;
      this.standardFieldSelected = false;
      return;
    }
    this.customFieldSelected = FieldService.isCustomField(this.breakdownField);
    this.standardFieldSelected = !this.customFieldSelected;
  }

  private setBreakdownFields(): void {
    this.breakdownFieldSet = this.getKeywordFieldSet();

    const hasBreakdownField = this.breakdownFieldSet.some(
      (item) => item.id === this.breakdownField
    );
    if (!hasBreakdownField) {
      this.breakdownField = null;
    }

    this.breakdownNumericMetadataFieldSet = this.getBreakdownNumericFieldSet();

    const hasPrimaryNumericMetadataField = this.breakdownNumericMetadataFieldSet.some(
      (item) => item.id === this.breakDownOptions.primary.numericMetadataFieldId
    );
    if (!hasPrimaryNumericMetadataField) {
      this.breakDownOptions.primary.numericMetadataFieldId = 'docs';
    }

    const optionToSkip =
      this.breakDownOptions.primary.numericMetadataFieldId === 'docs' ? 'docs' : null;
    this.breakdownSecondaryNumericMetadataFieldSet = this.getBreakdownNumericFieldSet(optionToSkip);

    const hasSecondaryNumericMetadataField = this.breakdownSecondaryNumericMetadataFieldSet.some(
      (item) => item.id === this.breakDownOptions.secondary.numericMetadataFieldId
    );
    if (!hasSecondaryNumericMetadataField) {
      this.breakDownOptions.secondary.numericMetadataFieldId = null;
    }

    this.setBreakdownScoring(this.breakDownOptions?.primary ?? {});
    if (this.widget.payload.additionalBreakdownOptions) {
      this.setBreakdownScoring(this.breakDownOptions.secondary ?? {});
    }
  }

  get breakdownCanAddSecondaryAxis(): boolean {
    return this.breakdownNumericMetadataFieldSet?.length > 1;
  }

  getBreakdownNumericFieldSet(optionToDisable?: string) {
    return this.getAvailableNumericMetadataFieldSet()
      .map((item) => ({ ...item, disabled: item.id === optionToDisable }))
      .sort((a, b) => {
        return a.title.toLocaleLowerCase().localeCompare(b.title.toLocaleLowerCase());
      });
  }

  getAvailableNumericMetadataFieldSet() {
    const numericMetadataFieldSet = this.dsMetadataFields
      .filter((f) => FieldService.hasNumerics(f.type, f.calculationFieldType))
      .map((f) => ({
        title: f.label,
        id: f.name,
        disabled: false,
        isBinary: f.calculationType === 'binary',
      }));

    numericMetadataFieldSet.push({
      title: translate('widgets.widget-add.documents'),
      id: 'docs',
      disabled: false,
      isBinary: false,
    });
    return numericMetadataFieldSet;
  }

  private getKeywordFieldSet(): DropdownObject[] {
    if (!this.ds) {
      return [];
    }

    const ALLOWED_STANDARD_FIELDS = [
      'tags',
      'creator',
      'language',
      'publisher',
      'source',
      'type',
      'url',
    ];

    const standardFields = this.ds.standardFields
      .filter((f) => ALLOWED_STANDARD_FIELDS.includes(f))
      .map((f) => ({ title: capitalize(f), id: f }));

    const sectionPropertyFieldNames = (
      this.ds.sectionPropertyTypes?.length
        ? this.ds.sectionPropertyTypes.map(
            (propertyName) => `${Constants.SECTION_PROPERTIES_PREFIX}${propertyName}`
          )
        : this.sectionMetadata
            .filter((metadata) => metadata.type === 'property')
            .map((metadata) => metadata.fieldName)
    )
      .filter((fieldName) => Constants.SECTION_ALLOWED_PROPERTY_TYPES.includes(fieldName))
      .map((fieldName) => ({
        title: translate(`widgets.section-selector.${fieldName}`),
        id: fieldName,
      }));

    return this.dsMetadataFields
      .filter(
        (f) =>
          f.isDisplayed &&
          f.type === 'keyword' &&
          (!f.isRedacted || !this.authService.isAlwaysRedact)
      )
      .map((f) => ({ title: f.label, id: f.name }))
      .concat(standardFields)
      .concat(sectionPropertyFieldNames)
      .sort((a, b) => {
        return a.title.toLocaleLowerCase().localeCompare(b.title.toLocaleLowerCase());
      });
  }

  private setBreakdownScoring(
    optionToChange: Partial<WidgetAddBreakdownAxisOption>,
    shouldSetDefault = false,
    excludeBucket = false
  ): void {
    if (optionToChange.numericMetadataFieldId === 'docs') {
      optionToChange.scoringSet = this._breakdownScoringSet.filter((s) => s.id === 'sum');
      optionToChange.scoring = 'sum';
    } else if (
      !this.dsMetadataFields.find((f) => f.name === optionToChange.numericMetadataFieldId)?.isRating
    ) {
      if (optionToChange.isMetadataBinary) {
        optionToChange.scoringSet = this._breakdownScoringSet.filter((s) => s.id === 'avg');
        optionToChange.scoring = 'avg';
      } else {
        optionToChange.scoringSet = this._breakdownScoringSet.filter(
          (s) =>
            (s.id === 'avg' || s.id === 'sum' || s.id === 'bucket') &&
            !(excludeBucket && s.id === 'bucket')
        );
        if (shouldSetDefault) {
          optionToChange.scoring = 'avg';
        }
      }
    } else {
      optionToChange.scoringSet = excludeBucket
        ? this._breakdownScoringSet.filter((s) => s.id !== 'bucket')
        : this._breakdownScoringSet;
    }
  }

  private refreshBucketExclusivity(): void {
    const primaryUsesBucket = this.breakDownOptions.primary.scoring === 'bucket';
    const secondaryUsesBucket = this.breakDownOptions.secondary?.scoring === 'bucket';
    if (this.breakDownOptions.primary.numericMetadataFieldId) {
      this.setBreakdownScoring(this.breakDownOptions.primary, false, secondaryUsesBucket);
    }
    if (this.breakDownOptions.secondary?.numericMetadataFieldId) {
      this.setBreakdownScoring(this.breakDownOptions.secondary, false, primaryUsesBucket);
    }
  }

  onBreakdownNumericMetadataFieldChange(fieldId: string): void {
    this.breakDownOptions.primary.numericMetadataFieldId = fieldId;
    const secondaryUsesBucket = this.breakDownOptions.secondary?.scoring === 'bucket';
    const isNewFieldBinary =
      this.dsMetadataFields.find((f) => f.name === fieldId)?.calculationType === 'binary';
    this.breakDownOptions.primary.isMetadataBinary = isNewFieldBinary;
    this.setBreakdownScoring(this.breakDownOptions.primary, true, secondaryUsesBucket);
    this.breakDownOptions.primary.fieldBuckets = [];
    if (this.breakDownOptions.primary.scoring === 'bucket') {
      this.ensureBucketDefaults('primary');
      this.updateBucketValidation('primary');
    }
    const optionToSkip =
      this.breakDownOptions.primary.numericMetadataFieldId === 'docs' ? 'docs' : null;
    this.breakdownSecondaryNumericMetadataFieldSet = this.getBreakdownNumericFieldSet(optionToSkip);
    this.refreshBucketExclusivity();
  }

  onAdditionalBreakdownNumericMetadataFieldChange(fieldId: string) {
    this.breakDownOptions.secondary.numericMetadataFieldId = fieldId;
    const primaryUsesBucket = this.breakDownOptions.primary.scoring === 'bucket';
    const isNewFieldBinary =
      this.dsMetadataFields.find((f) => f.name === fieldId)?.calculationType === 'binary';
    this.breakDownOptions.secondary.isMetadataBinary = isNewFieldBinary;
    this.setBreakdownScoring(this.breakDownOptions.secondary, true, primaryUsesBucket);
    this.breakDownOptions.secondary.fieldBuckets = [];
    if (this.breakDownOptions.secondary.scoring === 'bucket') {
      this.ensureBucketDefaults('secondary');
      this.updateBucketValidation('secondary');
    }
    const optionToSkip =
      this.breakDownOptions.secondary.numericMetadataFieldId === 'docs' ? 'docs' : null;
    this.breakdownNumericMetadataFieldSet = this.getBreakdownNumericFieldSet(optionToSkip);
    this.refreshBucketExclusivity();
  }

  private getOptionObject(scoringId: string, breakdownOptions: Partial<BreakdownOptions>) {
    const boxScoringDisplayData = BoxScoringDisplayDataUtils.getObjectDefaults();
    const objectExtractor = () => {
      switch (scoringId) {
        case 'box':
          return {
            min: 1,
            max: 5,
            boxScoringDisplayData: {
              ...boxScoringDisplayData,
              defaultColorPalette: this.data.defaultColorPalette,
            },
            ...(breakdownOptions && {
              boxScoringDisplayData: {
                ...boxScoringDisplayData,
                topColor: breakdownOptions.topColor ?? boxScoringDisplayData.topColor,
                neutralColor:
                  boxScoringDisplayData.neutralColor ?? boxScoringDisplayData.neutralColor,
                bottomColor: boxScoringDisplayData.bottomColor ?? boxScoringDisplayData.bottomColor,
              },
            }),
          };
        case 'nps':
          return {
            min: 0,
            max: 10,
            boxScoringDisplayData: undefined,
          };
        case 'bucket':
          return {
            min: undefined,
            max: undefined,
            boxScoringDisplayData: undefined,
            fieldBuckets: breakdownOptions.fieldBuckets ?? [],
          };
        default:
          return {
            min: undefined,
            max: undefined,
            boxScoringDisplayData: undefined,
          };
      }
    };
    const optionObject: Partial<WidgetAddBreakdownAxisOption> = {
      scoring: scoringId,
      ...(scoringId && {
        ...objectExtractor(),
      }),
    };
    return optionObject;
  }

  onBreakdownScoringChange(scoringId: string, breakdownOptions: Partial<BreakdownOptions>): void {
    this.assignNewValuesToPrimaryBreakdownOptions(scoringId, breakdownOptions);
  }

  onAdditionalBreakdownScoringChange(
    scoringId: string,
    breakdownOptions: Partial<BreakdownOptions>
  ) {
    this.assignNewValuesToSecondaryBreadownOptions(scoringId, breakdownOptions);
  }

  assignNewValuesToPrimaryBreakdownOptions(
    scoringId: string,
    breakdownOptions: Partial<BreakdownOptions>
  ) {
    this.breakDownOptions.primary = {
      ...this.breakDownOptions.primary,
      ...this.getOptionObject(scoringId, breakdownOptions),
    };
    if (scoringId === 'bucket') {
      this.ensureBucketDefaults('primary');
      this.updateBucketValidation('primary');
    }
    this.refreshBucketExclusivity();
  }

  assignNewValuesToSecondaryBreadownOptions(
    scoringId: string,
    breakdownOptions: Partial<BreakdownOptions>
  ) {
    this.breakDownOptions.secondary = {
      ...this.breakDownOptions.secondary,
      ...this.getOptionObject(scoringId, breakdownOptions),
    };
    if (scoringId === 'bucket') {
      this.ensureBucketDefaults('secondary');
      this.updateBucketValidation('secondary');
    }
    this.refreshBucketExclusivity();
  }

  onBucketsChanged(axis: BreakdownAxisKey): void {
    if (this.breakDownOptions[axis].scoring !== 'bucket') {
      return;
    }
    this.ensureBucketDefaults(axis);
    this.updateBucketValidation(axis);
  }

  onAddBucket(axis: BreakdownAxisKey): void {
    const currentBuckets = this.breakDownOptions[axis].fieldBuckets ?? [];
    const nextBucket = this.createDefaultBucket(currentBuckets.length);
    this.breakDownOptions[axis].fieldBuckets = [...currentBuckets, nextBucket];
    this.updateBucketValidation(axis);
  }

  onDeleteBucket(axis: BreakdownAxisKey, index: number): void {
    const currentBuckets = this.breakDownOptions[axis].fieldBuckets ?? [];
    if (currentBuckets.length <= 1) {
      return;
    }
    this.breakDownOptions[axis].fieldBuckets = currentBuckets.filter((_, i) => i !== index);
    this.updateBucketValidation(axis);
  }

  private ensureBucketDefaults(axis: BreakdownAxisKey): void {
    const currentBuckets = this.breakDownOptions[axis].fieldBuckets ?? [];
    if (currentBuckets.length > 0) {
      return;
    }
    const fieldName = this.breakDownOptions[axis].numericMetadataFieldId;
    if (fieldName) {
      const defaultBuckets = this.getDefaultBucketDefinitionsForField(fieldName);
      if (defaultBuckets?.length) {
        this.breakDownOptions[axis].fieldBuckets = this.cloneBucketDefinitions(defaultBuckets);
        return;
      }
    }
    this.breakDownOptions[axis].fieldBuckets = [this.createDefaultBucket(0)];
  }

  private createDefaultBucket(index: number): FieldBucketDefinition {
    return {
      bucketName: `Bucket ${index + 1}`,
      minimumValue: 0,
      maximumValue: 1,
      includeMinimum: true,
      includeMaximum: false,
      color: this.getDefaultBucketColor(index),
    };
  }

  private updateBucketValidation(axis: BreakdownAxisKey): void {
    const buckets = this.breakDownOptions[axis].fieldBuckets ?? [];
    this.bucketValidationError[axis] = this.validateBuckets(buckets);
  }

  private validateBuckets(buckets: FieldBucketDefinition[]): string | undefined {
    if (!buckets.length) {
      return translate('widgets.widget-add.bucket-validation-required');
    }
    const normalizedNames = new Set<string>();
    for (const bucket of buckets) {
      const name = bucket.bucketName?.trim();
      if (!name) {
        return translate('widgets.widget-add.bucket-validation-name-required');
      }
      const normalizedName = name.toLowerCase();
      if (normalizedNames.has(normalizedName)) {
        return translate('widgets.widget-add.bucket-validation-name-unique');
      }
      normalizedNames.add(normalizedName);

      const min = this.coerceToNumber(bucket.minimumValue);
      const max = this.coerceToNumber(bucket.maximumValue);
      if (Number.isNaN(min) || Number.isNaN(max)) {
        return translate('widgets.widget-add.bucket-validation-number');
      }
      if (!(min < max)) {
        return translate('widgets.widget-add.bucket-validation-min-max');
      }
    }

    const sortedBuckets = [...buckets]
      .map((b) => ({
        ...b,
        minimumValue: this.coerceToNumber(b.minimumValue),
        maximumValue: this.coerceToNumber(b.maximumValue),
      }))
      .sort((a, b) => {
        if (a.minimumValue !== b.minimumValue) {
          return a.minimumValue - b.minimumValue;
        }
        return a.maximumValue - b.maximumValue;
      });

    for (let i = 0; i < sortedBuckets.length - 1; i += 1) {
      const left = sortedBuckets[i];
      const right = sortedBuckets[i + 1];
      if (right.minimumValue < left.maximumValue) {
        return translate('widgets.widget-add.bucket-validation-overlap');
      }
      if (right.minimumValue === left.maximumValue && left.includeMaximum && right.includeMinimum) {
        return translate('widgets.widget-add.bucket-validation-overlap');
      }
    }
    return undefined;
  }

  private coerceToNumber(value: unknown): number {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        return Number.NaN;
      }
      return Number(trimmed);
    }
    return Number.NaN;
  }

  get canShowBlank() {
    return (
      this.customFieldSelected &&
      (this.isCustomDoubleSelected || this.isCustomLongSelected) &&
      this.widget.payload.type === 'documentCount' &&
      (this.widget.payload.aggregator === 'total' ||
        this.widget.payload.aggregator === 'percentage')
    );
  }

  get isNoteWidgetSelected() {
    return this.selectedWidget?.type === 'note' || this.selectedWidget?.type === 'noteMarkdown';
  }

  get isInsightFeedWidgetSelected() {
    return this.selectedWidget?.type === 'insightFeed';
  }

  onInsightFeedSourceChange(feedSource: { source: WidgetInsightFeedSource; query: string[] }) {
    this.widget.payload.feedSource = feedSource.source;
    if (feedSource.query) {
      this.widget.payload.feedQuery = feedSource.query;
    } else {
      delete this.widget.payload.feedQuery;
    }
  }

  cancelSecondaryAxis() {
    this.breakDownOptions.secondary = {};
    delete this.widget.payload.additionalBreakdownOptions;
    this.breakdownSecondaryAxisAdded = false;
  }

  hasDefaultBuckets(axis: BreakdownAxisKey): boolean {
    const fieldName = this.breakDownOptions[axis].numericMetadataFieldId;
    if (!fieldName) {
      return false;
    }
    return (this.getDefaultBucketDefinitionsForField(fieldName)?.length ?? 0) > 0;
  }

  currentBucketsMatchDefaults(axis: BreakdownAxisKey): boolean {
    const fieldName = this.breakDownOptions[axis].numericMetadataFieldId;
    if (!fieldName) {
      return false;
    }

    const defaultBuckets = this.getDefaultBucketDefinitionsForField(fieldName);
    if (!defaultBuckets?.length) {
      return false;
    }
    const currentBuckets = this.breakDownOptions[axis].fieldBuckets ?? [];
    if (currentBuckets.length !== defaultBuckets.length) {
      return false;
    }

    return currentBuckets.every((current, index) =>
      this.areBucketDefinitionsEquivalent(current, defaultBuckets[index])
    );
  }

  restoreBucketsToDefault(axis: BreakdownAxisKey): void {
    const fieldName = this.breakDownOptions[axis].numericMetadataFieldId;
    if (!fieldName) {
      return;
    }

    const defaultBuckets = this.getDefaultBucketDefinitionsForField(fieldName);
    if (!defaultBuckets?.length) {
      return;
    }

    this.breakDownOptions[axis].fieldBuckets = this.cloneBucketDefinitions(defaultBuckets);
    this.updateBucketValidation(axis);
  }

  private getDefaultBucketColor(index: number): FieldBucketDefinition['color'] {
    const defaultColors: FieldBucketDefinition['color'][] = [
      { red: 85, green: 191, blue: 59, alpha: 1 },
      { red: 146, green: 146, blue: 146, alpha: 1 },
      { red: 223, green: 83, blue: 83, alpha: 1 },
    ];
    const palette = this.data.defaultColorPalette;
    const paletteColor = palette?.length ? palette[index % palette.length] : undefined;
    return defaultColors[index] ?? paletteColor ?? defaultColors[0];
  }

  private getDefaultBucketDefinitionsForField(
    fieldName: string
  ): FieldBucketDefinition[] | undefined {
    const cached = this.defaultBucketDefinitionsByField.get(fieldName);
    if (cached) {
      return cached;
    }

    const field = this.accountMetadataFields.find((f) => f.fieldName === fieldName);
    const buckets = field?.buckets;
    if (!buckets?.length) {
      return undefined;
    }

    const definitions = buckets.map((bucket, index) => ({
      bucketName: bucket.bucketName,
      minimumValue: bucket.minimumValue,
      maximumValue: bucket.maximumValue,
      includeMinimum: bucket.includeMinimum,
      includeMaximum: bucket.includeMaximum,
      color: this.getDefaultBucketColor(index),
    }));

    this.defaultBucketDefinitionsByField.set(fieldName, definitions);
    return definitions;
  }

  private cloneBucketDefinitions(buckets: FieldBucketDefinition[]): FieldBucketDefinition[] {
    return Utils.deepCloneWithNulls(buckets);
  }

  private areBucketDefinitionsEquivalent(
    left: FieldBucketDefinition,
    right: FieldBucketDefinition
  ): boolean {
    return (
      left.bucketName?.trim() === right.bucketName?.trim() &&
      this.coerceToNumber(left.minimumValue) === this.coerceToNumber(right.minimumValue) &&
      this.coerceToNumber(left.maximumValue) === this.coerceToNumber(right.maximumValue) &&
      left.includeMinimum === right.includeMinimum &&
      left.includeMaximum === right.includeMaximum
    );
  }
}
